import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Input, Button, Table, Icon } from 'antd'

@inject((store: any) => {
    const { insuranceCalculatorStore, popupStore } = store
    return { insuranceCalculatorStore, popupStore }
})
@observer
export default class InsuranceCalculatorComparasionsPopup extends Component<any, any> {
    handleShowParamsPopup = async name => {
        const { popupStore, insuranceCalculatorStore } = this.props
        await insuranceCalculatorStore.getInsuranceCalculatorParameters(name)
        popupStore.togglePopup('insuranceCalculatorParamsPopup')
    }
    closePopup = () => {
        if (this.props.insuranceCalculatorStore.headers) {
            this.props.popupStore.togglePopup('insuranceCalculatorComparasions')
        } else {
            this.props.popupStore.togglePopup(false)
        }
    }
    render() {
        const { popupStore, insuranceCalculatorStore } = this.props
        let { index, comparisons, rights } = insuranceCalculatorStore
        comparisons = JSON.parse(JSON.stringify(comparisons))
        let comparison1 = comparisons.names ? comparisons.names[index][0] : ''
        let comparison2 = comparisons.names ? comparisons.names[index][1] : ''
        return (
            <Modal
                title={
                    <div>
                        הזכויות אשר מכוסות בתוך הפוליסות:
                        <div style={{ fontWeight: 'normal' }}>{comparison1}</div>
                        <div style={{ fontWeight: 'normal' }}>{comparison2}</div>
                    </div>
                }
                visible={popupStore.popupType === 'insuranceCalculatorRights'}
                closeIcon={<Icon type="right" />}
                cancelText="ביטול"
                onCancel={this.closePopup}
                footer={null}
                width={600}
            >
                <div style={{ paddingBottom: '2rem' }}>
                    {rights.map((right, index) => (
                        <div key={index} style={{ display: 'flex', backgroundColor: 'orange' }}>
                            {typeof right === 'string' ? (
                                <div
                                    onClick={() => this.handleShowParamsPopup(right)}
                                    style={{
                                        border: '1px solid black',
                                        fontWeight: 'bold',
                                        flex: 1,
                                        cursor: 'pointer'
                                    }}
                                >
                                    {right}
                                </div>
                            ) : (
                                <div style={{ border: '1px solid black', flex: 1 }}>
                                    {Object.keys(right)[0]}
                                    <small>
                                        הזכות הנ"ל מכוסה רק ב{Object.values(right)[0] == 1 ? comparison1 : comparison2}
                                    </small>
                                </div>
                            )}
                        </div>
                    ))}
                    <div style={{ display: 'flex', marginBottom: '1rem' }}></div>
                </div>
            </Modal>
        )
    }
}
